var _marker, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeuralNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "a",
    overflow: "visible",
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.1,0,0,-1.1,-1.1,0)",
    d: "m8.7186 4.0337-10.926-4.0177 10.926-4.0177c-1.7455 2.3721-1.7354 5.6175-6e-7 8.0354z",
    stroke: "#000",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ccecff",
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 360,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 280,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 200,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 40,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 120,
    r: 20
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 150,
    r: 20,
    fill: "#cfc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 250,
    r: 20,
    fill: "#cfc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 200,
    r: 20,
    fill: "#ff9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140 150 140-110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 250 140-210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 150 140-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 250 140-130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 150 140 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 250 140-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 150 140 130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 250 140 30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 150 140 210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 250 140 110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 40 140 160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 120 140 80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 200h140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 280 140-80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320 360 140-160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 150h50",
    markerEnd: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m515 200h50",
    markerEnd: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 250h50",
    markerEnd: "url(#a)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuralNetwork);
export default __webpack_public_path__ + "static/media/Neural_network.0d99f4ce0bb718df3354720b7fc03dcb.svg";
export { ForwardRef as ReactComponent };